<script setup></script>

<template>
  <Page v-slot="{ page }" code="legal-notice" :hero="true">
    <div class="mx-auto max-w-screen-md px-4 py-16">
      <div class="text-center text-zinc-500">
        VERSION MISE À JOUR LE
        {{ new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(page.updatedAt)).toUpperCase() }}
      </div>
      <Markdown class="mx-auto mt-8" :content="page.content" />
    </div>
  </Page>
</template>
